import React from "react";
import { EMAIL } from "../site/constants";
import ContentPage, { Block } from "../components/ContentPage";

export default function DeleteAccountPage() {
  return (
    <ContentPage
      title="Account verwijderen"
      lead="Je kunt je Suriwebwinkel-account verwijderen via de mobiele app of door contact met ons op te nemen."
      ctaLabel={null}
    >
      <Block title="Via de app">
        <ol>
          <li>Open de Suriwebwinkel app en log in.</li>
          <li>Ga naar Profiel → Instellingen.</li>
          <li>Kies Account verwijderen en bevestig.</li>
        </ol>
      </Block>
      <Block title="Via e-mail">
        <p>
          Stuur een verzoek naar <a href={`mailto:${EMAIL}`}>{EMAIL}</a> vanaf
          het e-mailadres dat aan je account is gekoppeld. Vermeld dat je je
          account wilt laten verwijderen. We verwerken je verzoek binnen een
          redelijke termijn.
        </p>
      </Block>
      <Block title="Wat wordt verwijderd?">
        <p>
          Bij verwijdering wissen we je accountgegevens en persoonlijke data die
          niet langer nodig zijn voor wettelijke of administratieve doeleinden
          (bijvoorbeeld afgeronde bestellingen waar bewaarplicht geldt).
        </p>
      </Block>
    </ContentPage>
  );
}
